module.exports = __webpack_public_path__ + "img/iphone.7d49a6b8.png";